/** Situações da entidade LinhaProducao */
export interface LinhaProducaoSituacao {
    id: number,
    nome: string;
}

export const linhaProducaoAtiva: LinhaProducaoSituacao = {id: 1, nome: 'Ativa'};
export const linhaProducaoInativa: LinhaProducaoSituacao = {id: 2, nome: 'Inativa'};

export const linhaProducaoSituacoes: LinhaProducaoSituacao[] = [
    linhaProducaoAtiva,
    linhaProducaoInativa
];
